import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  useApiClient, useFetch,
} from '@marageti/z4-lib';
import { Partner } from '@marageti/z4-sdk/lib/travel';
import { enqueueSnackbar } from 'notistack';
import View from './profile-view';

const Container = () => {
  const { partnerId } = useParams();
  const apiClient = useApiClient();

  const { data: partner, mutate } = useFetch<Partner>(apiClient.partnersClient.getPartner, [partnerId], true);

  const prlValue = partner?.partnerReferralProgram;

  const handleUpdatePRLValue = async (newValue: boolean) => {
    if (partnerId && partner) {
      await apiClient.partnersClient.putPartnerProfile(partnerId, { ...partner, partnerReferralProgram: newValue });
      mutate();
    }
  };

  const [editorsOpen, setEditorsOpen] = useState<{ [key: string]: boolean }>({});
  const [contextMenusOpen, setContextMenusOpen] = useState<{ [key: string]: boolean }>({});
  const [contextMenuAnchors, setContextMenuAnchors] = useState<{ [key: string]: HTMLElement | null }>({});

  const handleOpenContextMenu = (attributeName: string, e: React.MouseEvent<HTMLButtonElement>) => {
    const updatedContextMenuAnchors = {
      ...contextMenuAnchors,
      [attributeName]: e.currentTarget || null,
    };
    const updatedContextMenusOpen = {
      ...contextMenusOpen,
      [attributeName]: true,
    };
    setContextMenusOpen(updatedContextMenusOpen);
    setContextMenuAnchors(updatedContextMenuAnchors);
  };
  const handleCloseContextMenu = (attributeName: string) => {
    const updatedContextMenuAnchors = {
      ...contextMenuAnchors,
      [attributeName]: null,
    };
    const updatedContextMenusOpen = {
      ...contextMenusOpen,
      [attributeName]: false,
    };
    setContextMenusOpen(updatedContextMenusOpen);
    setContextMenuAnchors(updatedContextMenuAnchors);
  };

  const handleCloseEditor = (attributeName: string) => {
    const updatedEditorsOpen = {
      ...editorsOpen,
      [attributeName]: false,
    };
    setEditorsOpen(updatedEditorsOpen);
    handleCloseContextMenu(attributeName);
  };
  const handleOpenEditor = (attributeName: string) => {
    const updatedEditorsOpen = {
      ...editorsOpen,
      [attributeName]: true,
    };
    setEditorsOpen(updatedEditorsOpen);
  };

  const handleEditAvatar = async (avatar: string) => {
    if (partner) {
      try {
        const { avatar: updatedAvatar } = await apiClient.partnersClient.putPartnerAvatar(partner.id, {
          id: partner.id,
          avatar,
        });
        mutate({ ...partner, avatar: updatedAvatar }, { revalidate: false });
      } catch (error) {
        enqueueSnackbar('The image could not be uploaded', { variant: 'default' });
      }
    }
  };

  return (
    <View
      contextMenuAnchors={contextMenuAnchors}
      contextMenusOpen={contextMenusOpen}
      editorsOpen={editorsOpen}
      onCloseContextMenu={handleCloseContextMenu}
      onCloseEditor={handleCloseEditor}
      onEditAvatar={handleEditAvatar}
      onOpenContextMenu={handleOpenContextMenu}
      onOpenEditor={handleOpenEditor}
      partner={partner}
      prlValue={prlValue}
      onUpdatePRLValue={handleUpdatePRLValue}
    />
  );
};

export default Container;
